import { jsxs as d, jsx as o, Fragment as u } from "react/jsx-runtime";
import { useMemo as _, useState as h } from "react";
import { isArrayWithItems as m } from "../../../../../helpers/array-helper.js";
import { ListHeader as A } from "../list-header/list-header.js";
import { StationRow as f } from "../station-row/station-row.js";
import e from "./list.module.less.js";
import "dayjs";
import { useTranslation as O } from "react-i18next";
import "../../../../../contexts/global-context.js";
import "motion/react";
import { OutlineButton as C } from "../../../../../components/elements/button/button.js";
import "@radix-ui/react-dialog";
import "@radix-ui/react-accordion";
import "@vis.gl/react-google-maps";
import "haversine-distance";
import { extendStationsWithDistanceAndSortByUserPosition as g } from "../../../helpers/geo-helper.js";
const E = 15, G = ({ items: s, selectedStationCode: p, onClickStation: T, geolocation: r }) => {
  const { t: n } = O(), i = _(() => r ? g(r, s) : s, [s, r]), [l, S] = h(1), c = l * E, N = i.length > c, a = m(i) ? i.slice(0, c) : [];
  return /* @__PURE__ */ d("div", { className: e.wrapper, children: [
    a.length === 0 && /* @__PURE__ */ o("p", { className: `${e.noStations} body-base mb-0`, children: n("FIND_STATION_LIST_NO_STATION_MATCH_QUERY") }),
    a.length > 0 && /* @__PURE__ */ d(u, { children: [
      /* @__PURE__ */ o(
        A,
        {
          title: n("FIND_STATION_LIST_TITLE"),
          numberOfStations: s.length,
          icon: "ui-icon-bolt-filled",
          iconText: n("FIND_STATION_LIST_CHARGE_ICON_EXPLANATION")
        }
      ),
      /* @__PURE__ */ o("ul", { className: e.list, children: a?.map((t, I) => /* @__PURE__ */ o("li", { className: e.row, children: /* @__PURE__ */ o(
        f,
        {
          onClickStation: () => T(t.stationCode, { lat: t.latitude, lng: t.longitude }),
          stationConcept: t.stationConcept,
          stationType: t.stationType,
          name: t.stationName,
          hasElectricalCharging: m(t.electricConnectors),
          streetAdress: t?.streetAddress,
          distanceInKm: t.distanceInMeters ? Math.round(t.distanceInMeters / 1e3) : void 0,
          isSelected: t.stationCode === p
        }
      ) }, I)) }),
      N && /* @__PURE__ */ o("div", { className: e.showMoreButtonWrapper, children: /* @__PURE__ */ o(
        C,
        {
          isFullWidth: !0,
          className: e.showMoreButton,
          onClick: () => {
            S(l + 1);
          },
          label: n("FIND_STATION_SHOW_MORE_STATIONS")
        }
      ) })
    ] })
  ] });
};
export {
  G as List,
  G as default
};
